import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { OnboardingAdapter } from '../../adapters/onboarding.adapter';
import {
  loadAccountCompletion,
  loadAccountCompletionFailure,
  loadAccountCompletionSuccess,
  skipAccountCompletion,
  skipAccountCompletionFailure,
  skipAccountCompletionSuccess,
} from './account-completion.actions';

@Injectable()
export class AccountCompletionEffects {
  private readonly actions$ = inject(Actions);
  private readonly onboardingAdapter = inject(OnboardingAdapter);

  loadAccountCompletion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAccountCompletion),
      exhaustMap(() =>
        this.onboardingAdapter.getAccountCompletion().pipe(
          map((accountCompletion) =>
            loadAccountCompletionSuccess({ accountCompletion })
          ),
          catchError((error) => of(loadAccountCompletionFailure({ error })))
        )
      )
    )
  );

  skipAccountCompletion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(skipAccountCompletion),
      exhaustMap(() =>
        this.onboardingAdapter.skipAccountCompletion().pipe(
          map((accountCompletion) =>
            skipAccountCompletionSuccess({ accountCompletion })
          ),
          catchError((error) => of(skipAccountCompletionFailure({ error })))
        )
      )
    )
  );
}
